import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import Tooltip from "@material-ui/core/Tooltip";
import { Autocomplete } from "@mui/material";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import TextField from "@material-ui/core/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@material-ui/icons/Edit";
import Utils from "../../../provider/Utils";
import store from "../../../redux/store";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Col, Row } from "reactstrap";
import {
  AccessAccount_Url,
  ApDeleteRegistration_Url,
  ApEnableRegistration_Url,
  ApGetRegistration_Url,
  ApPauseRegistration_Url,
  ApUpdateTextMessageLength_Url,
  ApUpdateTrainingStatus_Url,
  closeAccount_Url,
  Static_Url,
} from "../../../provider/ServiceUrl";
import AdminRegistrationNote from "./AdminRegistrationNote";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
import headerAction from "../../../redux/header/headerAction";
import BackIconButton from "../../givBee/buttons/BackIconButton";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import CrmIntegrationAction from "../../../redux/crmIntegration/CrmIntegrationAction";
import SaveButton from "../../givBee/buttons/SaveButton";
import InfoTooltip from "../../givBee/infoTooltip/InfoTooltip";

class AdminRegistration extends Component {
  header = store.getState().adminHeader.adminHeader;
  trainingStatusList = store.getState().adminStaticData.trainingStatusList;
  accountStatusList = store.getState().adminStaticData.accountStatusList;
  title = "Account Details";
  breadCrumb = [
    { pageid: "/accountList", uiname: "Accounts List" },
    { pageid: "", uiname: "Account" },
  ];

  constructor(props) {
    super(props);
    let action = props.action;
    let accountId = props.accountId;
    if (!action && props.state) {
      action = props.state.action;
      accountId = props.state.accountId;
    }
    if (
      action &&
      Utils.equalsIgnoreCase(
        action,
        "view" || Utils.equalsIgnoreCase(action, "update")
      )
    ) {
      this.getAccountDetails(accountId);
    }
    this.state = {
      action: action,
      initialPage: 0,
      pageSize: 20,
      userInitialPage: 0,
      userPageSize: 10,
      textMessageLength: 0,
      companyName: "",
      email: "",
      gstn: "",
      note: "",
      noteId: "",
      reason: "",
      donarCliendId: "",
      customerUid: "",
      userList: [],
      noteList: [],
      status: null,
      prevStatus: null,
      businessDomain: null,
      trainingStatus: null,
      planType: null,
      dpSalesPersonName: "",
      dpSalesPersonEmail: "",
      enableMms: false,
      enableVcard: false,
      enableWidget: false,
      enableImport: false,
      enableEventImport: false,
      enablePaymentIntegration: false,
      enableMsgTemplate: false,
      enableOverages: false,
      isStatus: false,
      isTrainingStatus: false,
      isTextMessageLength: false,
      isReason: false,
      getCreatePermission: false,
      getUpdatePermission: false,
      getDeletePermission: false,
      password: "",
      showPassword: false,
      accountStatusOpen: false,
      confirmWindowOpen: false,
      isStatusUpdate: true,
      isTrainingStatusUpdate: true,
      isPaging: false,
      isUserPaging: false,
      render: false,
    };
  }

  getAccountDetails(accountId) {
    const postObject = {
      header: this.header,
      account: {
        id: accountId,
      },
    };
    AdminFetchServerData.callPostService(ApGetRegistration_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDetails = output.data.account;
          let tollfreeNumber = output.data.tollfreeNumber;
          let smsCredits = output.data.smsCredits;
          let accounSettingstDetails = output.data.account.accountSettings;
          let userList = output.data.account.users;
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getCreatePermission = getPermission[1];
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let isPaging = false;
          if (accounSettingstDetails.notes.length > this.state.pageSize) {
            isPaging = true;
          }
          let isUserPaging = false;
          if (userList.length > this.state.userPageSize) {
            isUserPaging = true;
          }
          let accountCloseStatus = false;
          if (accountDetails?.status?.status === "Closed") {
            accountCloseStatus = true;
          }

          this.setState({
            render: true,
            isPaging: isPaging,
            accountCloseStatus: accountCloseStatus,
            isUserPaging: isUserPaging,
            id: accountDetails.id,
            companyName: accountDetails?.name,
            companyWebsite: accountDetails.website,
            email: accountDetails.email,
            gstn: accountDetails?.gstn,
            status: accountDetails?.status,
            isdisabled: accountDetails.isDisabled,
            createdon: accountDetails?.createdon,
            reason: accountDetails?.reason,
            businessDomain: accountDetails.businessDomain,
            donarCliendId: accountDetails.donarCliendId,
            customerUid: accountDetails.customerUid,
            enableVcard: accounSettingstDetails.enableVcard,
            enableMms: accounSettingstDetails.enableMms,
            enableWidget: accounSettingstDetails.enableWidget,
            enableImport: accounSettingstDetails.enableImport,
            enablePaymentIntegration: accounSettingstDetails.enablePaymentIntegration,
            enableEventImport: accounSettingstDetails.enableEventImport,
            enableMsgTemplate: accounSettingstDetails.enableMsgTemplate,
            enableOverages: accounSettingstDetails.enableOverages,
            trainingStatus: accounSettingstDetails.trainingStatus,
            textMessageLength: accounSettingstDetails.textMessageLength,
            dpSalesPersonName: accounSettingstDetails.dpSalesPersonName,
            dpSalesPersonEmail: accounSettingstDetails.dpSalesPersonEmail,
            tollfreeNumber: tollfreeNumber,
            smsCredits: smsCredits,
            userList: userList,
            noteList: accounSettingstDetails.notes,
            planUsed: accountDetails?.planUsed,
            planType: accountDetails?.planUsed?.planType,
            getCreatePermission: getCreatePermission,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        }
      })
      .catch((error) => { });
  }

  handleReasonChange(e) {
    this.setState({
      reason: e.target.value,
    });
  }

  handleNoteChange(e) {
    this.setState({
      note: e.target.value,
    });
  }

  handleEnableStatusChange() {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      credential: this.state.password,
    };
    AdminFetchServerData.callPostService(ApEnableRegistration_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountEnableDetails = output.data.account;
          let accountCloseStatus = false;
          if (accountEnableDetails?.status?.status === "Closed") {
            accountCloseStatus = true;
          }
          this.setState({
            render: true,
            password: "",
            isStatus: false,
            isReason: false,
            accountStatusOpen: false,
            accountCloseStatus: accountCloseStatus,
            id: accountEnableDetails.id,
            companyName: accountEnableDetails.name,
            companyWebsite: accountEnableDetails.website,
            email: accountEnableDetails.email,
            gstn: accountEnableDetails.gstn,
            isdisabled: accountEnableDetails.isDisabled,
            reason: accountEnableDetails.reason,
            createdon: accountEnableDetails.createdon,
            noteList: accountEnableDetails.accountSettings?.notes,
          });
        }
      })
      .catch((error) => { });
  }

  handlePauseStatusChange() {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      credential: this.state.password,
    };
    AdminFetchServerData.callPostService(ApPauseRegistration_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDisableDetails = output.data.account;
          let accountCloseStatus = false;
          if (accountDisableDetails?.status?.status === "Closed") {
            accountCloseStatus = true;
          }
          this.setState({
            render: true,
            password: "",
            accountCloseStatus: accountCloseStatus,
            accountStatusOpen: false,
            isStatus: false,
            isReason: false,
            id: accountDisableDetails.id,
            companyName: accountDisableDetails.name,
            companyWebsite: accountDisableDetails.website,
            email: accountDisableDetails.email,
            gstn: accountDisableDetails.gstn,
            isdisabled: accountDisableDetails.isDisabled,
            reason: accountDisableDetails.reason,
            createdon: accountDisableDetails.createdon,
            noteList: accountDisableDetails.accountSettings?.notes,
          });
        }
      })
      .catch((error) => { });
  }

  handleClosedStatusChange() {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      credential: this.state.password,
    };
    AdminFetchServerData.callPostService(closeAccount_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountCloseDetails = output.data.account;
          let accountCloseStatus = false;
          if (accountCloseDetails?.status?.status === "Closed") {
            accountCloseStatus = true;
          }
          this.setState({
            render: true,
            password: "",
            accountStatusOpen: false,
            isStatus: false,
            isReason: false,
            accountCloseStatus: accountCloseStatus,
            id: accountCloseDetails.id,
            companyName: accountCloseDetails.name,
            companyWebsite: accountCloseDetails.website,
            email: accountCloseDetails.email,
            gstn: accountCloseDetails.gstn,
            isdisabled: accountCloseDetails.isDisabled,
            reason: accountCloseDetails.reason,
            createdon: accountCloseDetails.createdon,
            noteList: accountCloseDetails.accountSettings?.notes,
          });
        }
      })
      .catch((error) => { });
  }

  viewCancel() {
    this.props.navigate("/accountList");
  }

  handleEnableMmsChange(e) {
    this.updateSMSflag(e.target.checked);
    this.setState({ enableMms: e.target.checked });
  }
  handleEnableVCardChange(e) {
    this.updateVCardflag(e.target.checked);
    this.setState({ enableVcard: e.target.checked });
  }
  handleEnableWidgetChange(e) {
    this.updateWidgetflag(e.target.checked);
    this.setState({ enableWidget: e.target.checked });
  }
  handleEnableImportChange(e) {
    this.updateImportflag(e.target.checked);
    this.setState({ enableImport: e.target.checked });
  }
  handleEnableEventImportChange(e) {
    this.updateImportEventflag(e.target.checked);
    this.setState({ enableEventImport: e.target.checked });
  }
  handleEnablePaymentIntegrationChange(e) {
    this.updatePaymentIntegratedflag(e.target.checked);
    this.setState({ enablePaymentIntegration: e.target.checked });
  }
  handleEnableMsgTemplateChange(e) {
    this.updateMsgTemplateflag(e.target.checked);
    this.setState({ enableMsgTemplate: e.target.checked });
  }
  handleEnableOveragesChange(e) {
    this.updateOveragesflag(e.target.checked);
    this.setState({ enableOverages: e.target.checked });
  }

  handleTrainingStatusChange(selectedValue) {
    this.setState({
      trainingStatus: selectedValue,
    });
  }

  handleStatusChange(selectedValue) {
    this.setState({
      status: selectedValue,
      accountStatusOpen: false,
    });
  }

  updateSMSflag(enableMms) {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      enableMms: enableMms,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/updateMmsFlag",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDetails = output.data.account;
          let accounSettingstDetails = output.data.account.accountSettings;
          let userList = output.data.account.users;
          this.setState({
            render: true,
            id: accountDetails.id,
            companyName: accountDetails.name,
            companyWebsite: accountDetails.website,
            email: accountDetails.email,
            gstn: accountDetails?.gstn,
            isdisabled: accountDetails.isDisabled,
            createdon: accountDetails?.createdon,
            reason: accountDetails?.reason,
            enableMms: accounSettingstDetails.enableMms,
            enableWidget: accounSettingstDetails.enableWidget,
            enableImport: accounSettingstDetails.enableImport,
            enablePaymentIntegration: accounSettingstDetails.enablePaymentIntegration,
            enableEventImport: accounSettingstDetails.enableEventImport,
            enableMsgTemplate: accounSettingstDetails.enableMsgTemplate,
            enableOverages: accounSettingstDetails.enableOverages,
            noteList: accounSettingstDetails?.notes,
            userList: userList,
          });
        }
      })
      .catch((error) => { });
  }
  updateVCardflag(enableVcard) {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      enableVcard: enableVcard,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/updateVcardFlag",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDetails = output.data.account;
          let accounSettingstDetails = output.data.account.accountSettings;
          let userList = output.data.account.users;
          this.setState({
            render: true,
            id: accountDetails.id,
            companyName: accountDetails.name,
            companyWebsite: accountDetails.website,
            email: accountDetails.email,
            gstn: accountDetails?.gstn,
            isdisabled: accountDetails.isDisabled,
            createdon: accountDetails?.createdon,
            reason: accountDetails?.reason,
            enableMms: accounSettingstDetails.enableMms,
            enableVcard: accounSettingstDetails.enableVcard,
            enableWidget: accounSettingstDetails.enableWidget,
            enableImport: accounSettingstDetails.enableImport,
            enablePaymentIntegration: accounSettingstDetails.enablePaymentIntegration,
            enableEventImport: accounSettingstDetails.enableEventImport,
            enableMsgTemplate: accounSettingstDetails.enableMsgTemplate,
            enableOverages: accounSettingstDetails.enableOverages,
            noteList: accounSettingstDetails?.notes,
            userList: userList,
          });
        }
      })
      .catch((error) => { });
  }

  updateWidgetflag(enableWidget) {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      enableWidget: enableWidget,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/updateWidgetFlag",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDetails = output.data.account;
          let accounSettingstDetails = output.data.account.accountSettings;
          let userList = output.data.account.users;
          this.setState({
            render: true,
            id: accountDetails.id,
            companyName: accountDetails.name,
            companyWebsite: accountDetails.website,
            email: accountDetails.email,
            gstn: accountDetails?.gstn,
            isdisabled: accountDetails.isDisabled,
            createdon: accountDetails?.createdon,
            reason: accountDetails?.reason,
            enableMms: accounSettingstDetails.enableMms,
            enableVcard: accounSettingstDetails.enableVcard,
            enableWidget: accounSettingstDetails.enableWidget,
            enableImport: accounSettingstDetails.enableImport,
            enablePaymentIntegration: accounSettingstDetails.enablePaymentIntegration,
            enableEventImport: accounSettingstDetails.enableEventImport,
            enableMsgTemplate: accounSettingstDetails.enableMsgTemplate,
            enableOverages: accounSettingstDetails.enableOverages,
            noteList: accounSettingstDetails?.notes,
            userList: userList,
          });
        }
      })
      .catch((error) => { });
  }

  updateImportflag(enableImport) {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      enableImport: enableImport,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/updateImportFlag",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDetails = output.data.account;
          let accounSettingstDetails = output.data.account.accountSettings;
          let userList = output.data.account.users;
          this.setState({
            render: true,
            id: accountDetails.id,
            companyName: accountDetails.name,
            companyWebsite: accountDetails.website,
            email: accountDetails.email,
            gstn: accountDetails?.gstn,
            isdisabled: accountDetails.isDisabled,
            createdon: accountDetails?.createdon,
            reason: accountDetails?.reason,
            enableMms: accounSettingstDetails.enableMms,
            enableVcard: accounSettingstDetails.enableVcard,
            enableWidget: accounSettingstDetails.enableWidget,
            enableImport: accounSettingstDetails.enableImport,
            enablePaymentIntegration: accounSettingstDetails.enablePaymentIntegration,
            enableEventImport: accounSettingstDetails.enableEventImport,
            enableMsgTemplate: accounSettingstDetails.enableMsgTemplate,
            enableOverages: accounSettingstDetails.enableOverages,
            noteList: accounSettingstDetails?.notes,
            userList: userList,
          });
        }
      })
      .catch((error) => { });
  }
  updateImportEventflag(enableEventImport) {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      enableEventImport: enableEventImport,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/updateEventImportFlag",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDetails = output.data.account;
          let accounSettingstDetails = output.data.account.accountSettings;
          let userList = output.data.account.users;
          this.setState({
            render: true,
            id: accountDetails.id,
            companyName: accountDetails.name,
            companyWebsite: accountDetails.website,
            email: accountDetails.email,
            gstn: accountDetails?.gstn,
            isdisabled: accountDetails.isDisabled,
            createdon: accountDetails?.createdon,
            reason: accountDetails?.reason,
            enableMms: accounSettingstDetails.enableMms,
            enableVcard: accounSettingstDetails.enableVcard,
            enableWidget: accounSettingstDetails.enableWidget,
            enableImport: accounSettingstDetails.enableImport,
            enablePaymentIntegration: accounSettingstDetails.enablePaymentIntegration,
            enableEventImport: accounSettingstDetails.enableEventImport,
            enableMsgTemplate: accounSettingstDetails.enableMsgTemplate,
            enableOverages: accounSettingstDetails.enableOverages,
            noteList: accounSettingstDetails?.notes,
            userList: userList,
          });
        }
      })
      .catch((error) => { });
  }
  updatePaymentIntegratedflag(enablePaymentIntegration) {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      enablePaymentIntegration: enablePaymentIntegration,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/updatePaymentIntegration",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDetails = output.data.account;
          let accounSettingstDetails = output.data.account.accountSettings;
          let userList = output.data.account.users;
          this.setState({
            render: true,
            id: accountDetails.id,
            companyName: accountDetails.name,
            companyWebsite: accountDetails.website,
            email: accountDetails.email,
            gstn: accountDetails?.gstn,
            isdisabled: accountDetails.isDisabled,
            createdon: accountDetails?.createdon,
            reason: accountDetails?.reason,
            enableMms: accounSettingstDetails.enableMms,
            enableVcard: accounSettingstDetails.enableVcard,
            enableWidget: accounSettingstDetails.enableWidget,
            enableImport: accounSettingstDetails.enableImport,
            enablePaymentIntegration: accounSettingstDetails.enablePaymentIntegration,
            enableEventImport: accounSettingstDetails.enableEventImport,
            enableMsgTemplate: accounSettingstDetails.enableMsgTemplate,
            enableOverages: accounSettingstDetails.enableOverages,
            noteList: accounSettingstDetails?.notes,
            userList: userList,
          });
        }
      })
      .catch((error) => { });
  }
  updateMsgTemplateflag(enableMsgTemplate) {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      enableMsgTemplate: enableMsgTemplate,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/updateMsgTemplate",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDetails = output.data.account;
          let accounSettingstDetails = output.data.account.accountSettings;
          let userList = output.data.account.users;
          this.setState({
            render: true,
            id: accountDetails.id,
            companyName: accountDetails.name,
            companyWebsite: accountDetails.website,
            email: accountDetails.email,
            gstn: accountDetails?.gstn,
            isdisabled: accountDetails.isDisabled,
            createdon: accountDetails?.createdon,
            reason: accountDetails?.reason,
            enableMms: accounSettingstDetails.enableMms,
            enableVcard: accounSettingstDetails.enableVcard,
            enableWidget: accounSettingstDetails.enableWidget,
            enableImport: accounSettingstDetails.enableImport,
            enablePaymentIntegration: accounSettingstDetails.enablePaymentIntegration,
            enableEventImport: accounSettingstDetails.enableEventImport,
            enableMsgTemplate: accounSettingstDetails.enableMsgTemplate,
            enableOverages: accounSettingstDetails.enableOverages,
            noteList: accounSettingstDetails?.notes,
            userList: userList,
          });
        }
      })
      .catch((error) => { });
  }
  updateOveragesflag(enableOverages) {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      enableOverages: enableOverages,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/updateOveragesFlag",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountDetails = output.data.account;
          let accounSettingstDetails = output.data.account.accountSettings;
          let userList = output.data.account.users;
          this.setState({
            render: true,
            id: accountDetails.id,
            companyName: accountDetails.name,
            companyWebsite: accountDetails.website,
            email: accountDetails.email,
            gstn: accountDetails?.gstn,
            isdisabled: accountDetails.isDisabled,
            createdon: accountDetails?.createdon,
            reason: accountDetails?.reason,
            enableMms: accounSettingstDetails.enableMms,
            enableVcard: accounSettingstDetails.enableVcard,
            enableWidget: accounSettingstDetails.enableWidget,
            enableImport: accounSettingstDetails.enableImport,
            enablePaymentIntegration: accounSettingstDetails.enablePaymentIntegration,
            enableEventImport: accounSettingstDetails.enableEventImport,
            enableMsgTemplate: accounSettingstDetails.enableMsgTemplate,
            enableOverages: accounSettingstDetails.enableOverages,
            noteList: accounSettingstDetails?.notes,
            userList: userList,
          });
        }
      })
      .catch((error) => { });
  }

  createNoteToBackend(newData, resolve, reject) {
    const postObject = {
      header: this.header,
      accountId: this.state.id,
      accountNote: { note: newData.note },
    };
    AdminFetchServerData.callPostService("/apAccountNotems/add", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getAccountDetails(this.state.id);
          resolve();
        } else {
          reject();
        }
      })
      .catch((error) => { });
  }

  updateNotesToBackend(newData, resolve, reject) {
    const postObject = {
      header: this.header,
      accountId: this.state.id,
      accountNote: {
        id: newData.id,
        note: newData.note,
      },
    };
    AdminFetchServerData.callPostService("/apAccountNotems/update", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let accountDetails = output.data.accountNote;
          let currentIndex = this.state.noteList.findIndex(
            (d) => d.id === accountDetails.id
          );
          let currentList = [...this.state.noteList];
          currentList.splice(currentIndex, 1, accountDetails);
          this.setState({
            noteList: currentList,
            isOpen: false,
          });
          resolve();
        } else {
          reject();
        }
      })
      .catch((error) => { });
  }
  deleteNoteToBackend(newData, resolve, reject) {
    const postObject = {
      header: this.header,
      accountId: this.state.id,
      accountNote: {
        id: newData.id,
      },
    };
    AdminFetchServerData.callPostService("/apAccountNotems/delete", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          const newList = this.state.noteList.filter((d) => d.id !== newData.id);
          this.setState({ noteList: newList });
          PtsAlert.success(output.message);
          resolve();
        } else {
          reject();
        }
      })
      .catch((error) => { });
  }

  addNotes() {
    let notes = this.state.noteList;
    let note = {
      note: "",
      operation: "add",
      action: "create",
      account: {
        id: this.state.id,
      },
      type: {
        type: "Note",
      },
    };
    notes.push(note);
    this.setState({
      noteList: notes,
    });
  }

  accountNoteRemove(item) {
    let items = [];
    if (item.operation && "update" === item.operation) {
      let index = item.index;

      for (let i = 0; i < this.state.noteList.length; i++) {
        let item = this.state.noteList[i];
        if (this.state.noteList[i].operation === "update" && index === i) {
          item.operation = "delete";
        }

        items.push(item);
      }

      this.setState({ noteList: items });
    }
    if (item.operation && "add" === item.operation) {
      let index = item.index;
      for (let i = 0; i < this.state.noteList.length; i++) {
        if (this.state.noteList[i].operation === "add" && index === i) {
          this.noteRefList.splice(i, 1);
        } else {
          items.push(this.state.noteList[i]);
        }
      }
      this.setState({ noteList: items });
    }
  }

  editAccountStatus() {
    if (this.state.status?.status === "Active") {
      this.setState((prevState) => ({
        prevStatus: prevState.status,
        isStatus: true,
        isReason: false,
      }));
    } else {
      this.setState((prevState) => ({
        prevStatus: prevState.status,
        isStatus: true,
        isReason: true,
      }));
    }
  }

  editStatusCancel() {
    this.setState((prevState) => ({
      status: prevState.prevStatus,
      isStatus: false,
    }));
  }
  editAccountTrainingStatus() {
    this.setState({
      isTrainingStatus: true,
    });
  }
  editAccountTextMessageLength() {
    this.setState({
      isTextMessageLength: true,
    });
  }
  handleTextMessageLengthChange(length) {
    this.setState({
      textMessageLength: length,
    });
  }
  updateStatusInBackend() {
    if (this.state.status.status === "Active") {
      this.handleEnableStatusChange();
    } else if (this.state.status?.status === "Paused") {
      this.handlePauseStatusChange();
    } else if (this.state.status?.status === "Closed") {
      this.handleClosedStatusChange();
    } else if (this.state.status.status === "Deleted") {
      this.deleteAccountInBackend();
    }
  }

  editTrainingStatusCancel() {
    this.setState({
      isTrainingStatus: false,
    });
  }
  editTextMessageCancel() {
    this.setState({
      isTextMessageLength: false,
    });
  }
  updateTrainingStatusInBackend() {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      trainingStatus: {
        id: this.state.trainingStatus?.id,
      },
    };
    AdminFetchServerData.callPostService(ApUpdateTrainingStatus_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accountEnableDetails = output.data.account;
          this.setState({
            render: true,
            isTrainingStatus: false,
            id: accountEnableDetails.id,
            companyName: accountEnableDetails.name,
            companyWebsite: accountEnableDetails.website,
            email: accountEnableDetails.email,
            gstn: accountEnableDetails.gstn,
            isdisabled: accountEnableDetails.isDisabled,
            reason: accountEnableDetails.reason,
            createdon: accountEnableDetails.createdon,
            noteList: accountEnableDetails.accountSettings?.notes,
            trainingStatus:
              accountEnableDetails.accountSettings?.trainingStatus,
          });
        }
      })
      .catch((error) => { });
  }

  updateTextMessageLengthInBackend() {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      textMessageLength: this.state.textMessageLength,
    };
    AdminFetchServerData.callPostService(
      ApUpdateTextMessageLength_Url,
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let accounSettingstDetails = output.data.account;
          this.setState({
            render: true,
            isTextMessageLength: false,
            textMessageLength:
              accounSettingstDetails.accountSettings.textMessageLength,
            noteList: accounSettingstDetails.accountSettings?.notes,
          });
        }
      })
      .catch((error) => { });
  }

  accountLoginToBackend() {
    store.dispatch(SelectedDomainAction.setSelectedDomain(""));
    store.dispatch(SelectedDomainAction.setEventState({}));
    // store.dispatch(CrmIntegrationAction.setCrmIntegration(""));
    const postObject = {
      header: {
        ...this.header,
        tid: this.state.id,
      },
      account: {
        id: this.state.id,
      },
    };
    AdminFetchServerData.callPostService(AccessAccount_Url, postObject).then(
      (response) => {
        if (response.status === "SUCCESS") {
          let output = response.data;
          this.processLoginSuccess(output);
        }
      }
    );
  }

  async processLoginSuccess(output_data) {
    await this.setStaticData(output_data.header);
    store.dispatch(headerAction.setHeader(output_data.header));
    store.dispatch(AppUserDataAction.setUserData(output_data));
    store.dispatch(AppUserDataAction.setUsage(output_data.smsCredits));
    store.dispatch(AppUserDataAction.setTollfreeNumber(output_data.tollfreeNumber));
    store.dispatch(AppUserDataAction.setTollfreeNumberStatus(output_data.tollFreeNumberStatus));
    store.dispatch(
      CrmIntegrationAction.setCrmIntegration(output_data.crmIntegration)
    );
    store.dispatch(
      AppUserDataAction.setOrganization(output_data.appuser?.organization)
    );
    let accountSetting = output_data?.accountSetting;
    store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));

    let logoData = {
      logo: output_data.appuser?.organization?.logo
        ? output_data.appuser?.organization?.logo
        : "",
      logoFilename: output_data.appuser?.organization?.logoFilename
        ? output_data.appuser?.organization?.logoFilename
        : "",
      logoFileextension: output_data.appuser?.organization?.logoFileextension
        ? output_data.appuser?.organization?.logoFileextension
        : "",
    };
    store.dispatch(AppUserDataAction.setLogo(logoData));
    if (output_data.isTollfreeNumberPurchased === true) {
      store.dispatch(SelectedTabAction.setSelectedTab(0));
    } else {
      store.dispatch(SelectedTabAction.setSelectedTab(1));
      if (output_data.cmpaigningInfoError) {
      }
    }
    let header = output_data.header;
    this.loadDashboardPage(header, output_data);
  }

  loadDashboardPage(header, output) {
    let menus = output?.appuser.profile?.menus.sort(
      (a, b) => a.displaysequence - b.displaysequence
    );
    // await this.setStaticData(header);
    store.dispatch(ActiveMenuAction.setActiveMenu(menus[0]?.pageid));

    // const DPTEXT_URL = process.env.REACT_APP_DPTEXT_URL;

    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      if (menu.isactive) {
        // if (this.state.businessDomain?.name === "DPText") {
        //   window.open(`${DPTEXT_URL}${menu.pageid}`, "_blank");
        // } else {
        window.open(menu.pageid, "_blank");
        // }
        break;
      }
    }
  }

  async setStaticData(header) {
    const postObject = {
      header: header,
    };

    try {
      const output = await AdminFetchServerData.callPostService(
        Static_Url,
        postObject
      );
      if (output.status === "SUCCESS") {
        store.dispatch(staticDataAction.setStaticData(output.data));
      } else {
      }
    } catch (error) {
    }
  }

  deleteAccountInBackend() {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      credential: this.state.password,
    };
    AdminFetchServerData.callPostService(
      ApDeleteRegistration_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({ password: "" });
        this.props.navigate("/accountList");
      }
    });
  }

  handleAccountStatusClose = () => {
    this.setState({
      accountStatusOpen: false,
      password: "",
    });
  };
  handleAccountStatusOpen = () => {
    this.setState({ accountStatusOpen: true });
  };

  toDeleteAuthorizedConfirmationWindow = () => {
    this.setState({ confirmWindowOpen: true, accountStatusOpen: false });
  };

  handleConfirmWindowClose = () => {
    this.setState({
      confirmWindowOpen: !this.state.confirmWindowOpen,
      status: Utils.getArrayElement(this.accountStatusList, 0),
    });
  };

  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  billingHistoryDetails() {
    this.props.navigate("/accountBilling", {
      state: {
        action: "view",
        accountId: this.state.id,
        businessDomain: this.state.businessDomain,
        planType: this.state.planType,
      },
    });
  }
  sendHistoryDetails() {
    if (this.state.businessDomain.name === "EventText") {
      this.props.navigate("/accountEventList", {
        state: {
          accountId: this.state.id,
          businessDomain: this.state.businessDomain,
        },
      });
    } else {
      this.props.navigate("/accountSendHistory", {
        state: {
          accountId: this.state.id,
          businessDomain: this.state.businessDomain,
        },
      });
    }
  }
  tollfreeNumberDetails() {
    this.props.navigate("/accountTollfreeNumber", {
      state: {
        action: "view",
        accountId: this.state.id,
        tollfreeNumberId: this.state.tollfreeNumber?.id,
      },
    });
  }
  UsageHistoryDetails() {
    this.props.navigate("/accountBilling", {
      state: {
        accountId: this.state.id,
      },
    });
  }

  accountLockToBackend(data) {
    const postObject = {
      header: this.header,
      accountId: this.state.id,
      userId: data.id,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/unlockUser",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        // PtsAlert.success(output.message);
        let userList = output.data.account.users;
        let isUserPaging = false;
        if (userList.length > this.state.userPageSize) {
          isUserPaging = true;
        }
        this.setState({
          render: true,
          isUserPaging: isUserPaging,
          userList: userList,
        });
      }
    });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ userInitialPage: page, userPageSize: pageSize });
  }

  approveMakePrimaryUserToBackend(data) {
    const postObject1 = {
      header: this.header,
      account: {
        id: this.state.id,
      },
      user: {
        id: data.id
      }
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/approvePrimaryUserChange",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.getAccountDetails(this.state.id);
      } else {
      }
    });
  }

  render() {
    const DPTEXT_URL = process.env.REACT_APP_DPTEXT_URL.trim();

    this.noteRefList = [];
    for (
      let i = 0;
      this.state.noteList && i < this.state.noteList.length;
      i++
    ) {
      this.noteRefList[i] = React.createRef();
    }
    if (this.state.render === false) {
      return <div />;
    }

    let taskNotes = [];
    let i = 0;

    for (const note of this.state.noteList ?? []) {
      if (note.operation !== "delete") {
        taskNotes.unshift(
          <div
            className="col-md-4"
            style={{ marginTop: "1em" }}
            key={note.id}
          >
            <AdminRegistrationNote
              ref={this.noteRefList[i]}
              data={note}
              srno={i}
              action={note.action ? note.action : "view"}
              type="appointment"
              noteId={this.state.noteId}
              pageId={this.state.pageId}
              onNoteDelete={this.deleteNoteToBackend.bind(this)}
              onDelete={this.accountNoteRemove.bind(this)}
              onNoteUpdate={this.updateNotesToBackend.bind(this)}
              addNote={this.createNoteToBackend.bind(this)}
            />
          </div>
        );
      }
      i++;
    }

    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          name={this.title}
        />
        <div className="row">
          <div className="col-md-6">
            <BackIconButton onClick={this.viewCancel.bind(this)} />
          </div>
          <div className="col-sm-6 text-end">
            {this.state.businessDomain?.name === "DPText" ? (
              < Button
                component="a"
                href={`${DPTEXT_URL}/accessDpTextAccount?s=${this.header.sessionid}&a=${this.state.id}`}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                style={{
                  background: "#5ac489",
                  color: "#fff",
                  textTransform: "capitalize",
                  padding: "2px 10px",
                }}
                startIcon={
                  <i
                    className="fa fa-sign-in"
                    aria-hidden="true"
                    style={{ color: "#fff", fontSize: "medium" }}
                  />
                }
              >
                Login
              </Button>) : (
              <Button
                type="submit"
                variant="contained"
                style={{
                  // width: "90px",
                  background: "#5ac489",
                  color: "#fff",
                  textTransform: "capitalize",
                  padding: "2px 10px",
                }}
                startIcon={
                  <i
                    class="fa fa-sign-in"
                    aria-hidden="true"
                    style={{ color: "#fff", fontSize: "medium" }}
                  ></i>
                }
                onClick={this.accountLoginToBackend.bind(this)}
              >
                Login
              </Button>
            )}
          </div>
        </div >
        <div
          className="row mt-1"
          style={{ padding: "1em", marginTop: "-12px" }}
        >
          <div className="col-md-12 p-0">
            <div className="row justify-content-space-between">
              <div className="col-md-6">
                <div
                  className="card"
                  id="organizationFormCard"
                  style={{ height: "100%" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12" id="OrganizationCol">
                        <h5 className="fw-bold"> Account Details</h5>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Company Name
                      </label>
                      <div
                        className="col-sm-9 d-flex flex-wrap"
                        id="OrganizationCol"
                      >
                        <span className="me-2">{this.state.companyName}</span>
                        {this.state.companyWebsite !== null && (
                          <a
                            className="anchortag"
                            target="_blank"
                            // href={
                            //   this.state.companyWebsite
                            //     ? this.state.companyWebsite
                            //     : ""
                            // }
                            href={
                              this.state.companyWebsite.includes("https://") ||
                                this.state.companyWebsite.includes("http://")
                                ? this.state.companyWebsite
                                : "http://" + this.state.companyWebsite
                            }
                          >
                            {`(${Utils.truncateString(
                              this.state.companyWebsite,
                              38
                            )})`}
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Created On
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        {this.state.createdon !== null &&
                          Utils.getUtcToLocal(this.state.createdon)
                        }
                      </div>
                    </div>
                    <div className="row">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        GivBee Platform
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        <span>{this.state.businessDomain?.name}</span>
                      </div>
                    </div>
                    <div className="row">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        GivBee ID
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        <span>{this.state.customerUid}</span>
                      </div>
                    </div>
                    {this.state.donarCliendId !== null && (
                      <div className="row">
                        <label
                          className="col-sm-3 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          DP Client ID
                        </label>
                        <div className="col-sm-9" id="OrganizationCol">
                          <span>{this.state.donarCliendId}</span>
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Tollfree Number
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        {this.state.accountCloseStatus === false ? (
                          <>
                            <span
                              className="anchortag"
                              style={{
                                color: "#1957b4",
                                cursor: "pointer",
                                fontSize: "16px",
                                marginRight: "6px",
                              }}
                              onClick={this.tollfreeNumberDetails.bind(this)}
                            >
                              {this.state.tollfreeNumber?.phone}
                            </span>
                            {this.state.tollfreeNumber !== null &&
                              <>
                                {this.state.tollfreeNumber?.verificationStatus !== "UnVerified" ?
                                  < span style={{ fontSize: "14px", color: "#666" }}>
                                    ({this.state.tollfreeNumber?.verificationStatus !== "Verified" ? this.state.tollfreeNumber?.verificationStatus : `Submitted on ${Utils.getUtcToLocal(this.state.tollfreeNumber?.createdon)}`})
                                  </span> :
                                  < span style={{ fontSize: "14px", color: "#666" }}>
                                    {Utils.equalsIgnoreCase(this.state.tollfreeNumber?.verificationStatus, "UnVerified") && "(Unverified)"}
                                  </span>
                                }
                              </>
                            }
                          </>
                        ) : (
                          "Requires new number upon to activate"
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Plan Type
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        {this.state.planUsed?.name}
                        <span
                          className="anchortag ps-1"
                          style={{
                            color: "#1957b4",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                          onClick={this.billingHistoryDetails.bind(this)}
                        >
                          (Billing History)
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Text Usage
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        {Utils.formatWithCommas(
                          this.state.smsCredits?.consumedCredits
                        )}
                        /
                        {Utils.formatWithCommas(
                          this.state.smsCredits?.availableCredits
                        )}
                        <span className="ms-1">
                          <InfoTooltip
                            data={`Outgoing: ${this.state.smsCredits?.outgoingCredits} / Incoming: ${this.state.smsCredits?.incomingCredits}`}
                            style={{
                              float: "none",
                              fontSize: "large",
                              marginBottom: "3px",
                            }}
                          />
                        </span>
                        <span
                          className="anchortag ps-1"
                          style={{
                            color: "#1957b4",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                          onClick={this.sendHistoryDetails.bind(this)}
                        >
                          (Usage History)
                        </span>
                      </div>
                    </div>
                    {this.state.businessDomain?.name === "DPText" && (
                      <>
                        <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            DP Sales Person
                          </label>
                          <div className="col-sm-9" id="OrganizationCol">
                            <span className="me-2">
                              {this.state.dpSalesPersonName}
                            </span>
                            (
                            <a
                              className="anchortag"
                              href={`mailto:${this.state.dpSalesPersonEmail}`}
                              // target="_blank"
                              rel="noopener noreferrer"
                            >
                              {this.state.dpSalesPersonEmail}
                            </a>
                            )
                          </div>
                        </div>
                      </>
                    )}
                    <hr />
                    {!this.state.isStatus ? (
                      <>
                        <div className="row" style={{ minHeight: "40px" }}>
                          <label
                            className="col-sm-3 col-form-label fw-bold align-self-center"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Account Status
                          </label>
                          <div className="col-sm-6" id="OrganizationCol">
                            <span>{this.state.status?.status}</span><br />
                          </div>
                          <div className="col-sm-3 text-start align-self-center">
                            <Button
                              variant="contained"
                              size="small"
                              style={{
                                background: "#d3d8de",
                                color: "#353538",
                                marginRight: "1rem",
                                float: "left",
                                padding: "2px 10px",
                                textTransform: "capitalize",
                              }}
                              startIcon={<EditIcon />}
                              onClick={this.editAccountStatus.bind(this)}
                            >
                              Edit
                            </Button>
                          </div>
                        </div>
                        {this.state.status?.status === "Closed" &&
                          <div className="row">
                            <span
                              className="danger"
                              style={{ color: "red", fontSize: "14px" }}
                            >
                              Account can be reopened by submitting user information(Use Case) to Twilio.
                            </span>
                          </div>
                        }
                      </>
                    ) : (
                      <div className="row">
                        <label
                          className="col-sm-3 col-form-label fw-bold align-self-center"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Account Status
                        </label>
                        <div className="col-sm-6 pe-0" id="OrganizationCol">
                          <Autocomplete
                            id="size-small-outlined"
                            size="small"
                            fullWidth
                            disableClearable
                            autoComplete="off"
                            options={this.accountStatusList}
                            value={this.state.status}
                            getOptionLabel={(option) => option.description}
                            defaultValue={this.state.status}
                            onChange={(event, value) => {
                              this.handleStatusChange(value);
                            }}
                            inputprops={{
                              style: { textTransform: "capitalize" },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="autoComplete"
                                style={{ background: "#fff" }}
                              />
                            )}
                          />
                        </div>
                        {this.state.isStatusUpdate && (
                          <div className="col-sm-3 text-start align-self-center">
                            {/* <Button
                          style={{
                            background: "#37517e",
                            color: "white",
                            fontSize: "x-larger",
                            textTransform: "capitalize",
                            cursor: "pointer",
                            padding: "5px 20px",
                            fontWeight: "600",
                          }}
                          onClick={(e) => this.updateStatusInBackend()}
                        >
                          Update
                        </Button> */}
                            <SaveButton
                              onClick={(e) => this.handleAccountStatusOpen()}
                            />
                            <ClearIcon
                              className="cancelIcon"
                              style={{
                                cursor: "pointer",
                                borderRadius: "50%",
                                border: "solid 2px",
                              }}
                              onClick={this.editStatusCancel.bind(this)}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div
                  className="card"
                  id="organizationFormCard"
                  style={{ height: "100%" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <h5 className="fw-bold">Account Settings</h5>
                    </div>
                    <div className="row mt-2" style={{ marginBottom: "30px" }}>
                      <div className="col-md-6">
                        <div className="row pt-1 d-flex flex-nowrap align-items-center">
                          <label className="fw-bold " style={{ width: "165px" }}>
                            Add MMS
                          </label>
                          <label class="switch" style={{ width: "50px" }}>
                            <input
                              type="checkbox"
                              checked={this.state.enableMms}
                              value={this.state.enableMms}
                              onChange={this.handleEnableMmsChange.bind(this)}
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <div className="row pt-2 d-flex flex-nowrap align-items-center">
                          <label className="fw-bold " style={{ width: "165px" }}>
                            Opt-in Widget
                          </label>
                          <label class="switch" style={{ width: "50px" }}>
                            <input
                              type="checkbox"
                              checked={this.state.enableWidget}
                              value={this.state.enableWidget}
                              onChange={this.handleEnableWidgetChange.bind(this)}
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <div className="row pt-2 d-flex flex-nowrap align-items-center">
                          <label className="fw-bold " style={{ width: "165px" }}>
                            Import Contacts
                          </label>
                          <label class="switch" style={{ width: "50px" }}>
                            <input
                              type="checkbox"
                              checked={this.state.enableImport}
                              value={this.state.enableImport}
                              onChange={this.handleEnableImportChange.bind(this)}
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <div className="row pt-2 d-flex flex-nowrap align-items-center">
                          <label className="fw-bold " style={{ width: "165px" }}>
                            Allow Overages
                          </label>
                          <label class="switch" style={{ width: "50px" }}>
                            <input
                              type="checkbox"
                              checked={this.state.enableOverages}
                              value={this.state.enableOverages}
                              onChange={this.handleEnableOveragesChange.bind(this)}
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row pt-1 d-flex flex-nowrap align-items-center">
                          <label className="fw-bold " style={{ width: "180px" }}>
                            Add vCard
                          </label>
                          <label class="switch" style={{ width: "50px" }}>
                            <input
                              type="checkbox"
                              checked={this.state.enableVcard}
                              value={this.state.enableVcard}
                              onChange={this.handleEnableVCardChange.bind(this)}
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <div className="row pt-2 d-flex flex-nowrap align-items-center">
                          <label className="fw-bold " style={{ width: "180px" }}>
                            Message Templates
                          </label>
                          <label class="switch" style={{ width: "50px" }}>
                            <input
                              type="checkbox"
                              checked={this.state.enableMsgTemplate}
                              value={this.state.enableMsgTemplate}
                              onChange={this.handleEnableMsgTemplateChange.bind(
                                this
                              )}
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        {(this.state.businessDomain?.name === "EventText" && !Utils.equalsIgnoreCase(this.state.planType?.type, "Onetime")) &&
                          <div className="row pt-2 d-flex flex-nowrap align-items-center">
                            <label className="fw-bold " style={{ width: "180px" }}>
                              Import Events
                            </label>
                            <label class="switch" style={{ width: "50px" }}>
                              <input
                                type="checkbox"
                                checked={this.state.enableEventImport}
                                value={this.state.enableEventImport}
                                onChange={this.handleEnableEventImportChange.bind(this)}
                              />
                              <span class="slider round"></span>
                            </label>
                          </div>
                        }
                        {this.state.businessDomain?.name === "DPText" &&
                          <div className="row pt-2 d-flex flex-nowrap align-items-center">
                            <label className="fw-bold " style={{ width: "180px" }}>
                              Integrated Payments
                            </label>
                            <label class="switch" style={{ width: "50px" }}>
                              <input
                                type="checkbox"
                                checked={this.state.enablePaymentIntegration}
                                value={this.state.enablePaymentIntegration}
                                onChange={this.handleEnablePaymentIntegrationChange.bind(this)}
                              />
                              <span class="slider round"></span>
                            </label>
                          </div>
                        }
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row">
                      {!this.state.isTrainingStatus ? (
                        <div className="row" style={{ minHeight: "40px" }}>
                          <label
                            className="col-sm-3 col-form-label fw-bold align-self-center"
                            style={{ width: "165px" }}
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Training Status
                          </label>
                          <div
                            className="col-sm-5 align-self-center ms-0 ps-0"
                            id="OrganizationCol"
                          >
                            <span>{this.state.trainingStatus?.description}</span>
                          </div>
                          <div className="col-sm-3 text-start align-self-center">
                            <Button
                              variant="contained"
                              size="small"
                              style={{
                                background: "#d3d8de",
                                color: "#353538",
                                marginRight: "1rem",
                                float: "left",
                                padding: "2px 10px",
                                textTransform: "capitalize",
                              }}
                              startIcon={<EditIcon />}
                              onClick={this.editAccountTrainingStatus.bind(this)}
                            >
                              Edit
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div className="row ">
                          <label
                            className="col-sm-3 col-form-label fw-bold align-self-center"
                            style={{ width: "165px" }}
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Training Status
                          </label>
                          <div
                            className="col-sm-5 align-self-start  ms-0 ps-0"
                            id="OrganizationCol"
                          >
                            <Autocomplete
                              id="size-small-outlined"
                              size="small"
                              fullWidth
                              disableClearable
                              autoComplete="off"
                              options={this.trainingStatusList}
                              value={this.state.trainingStatus}
                              getOptionLabel={(option) => option.description}
                              defaultValue={this.state.trainingStatus}
                              onChange={(event, value) => {
                                this.handleTrainingStatusChange(value);
                              }}
                              inputprops={{
                                style: { textTransform: "capitalize" },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Please Select"
                                  variant="outlined"
                                  size="small"
                                  className="autoComplete"
                                  style={{ background: "#fff" }}
                                />
                              )}
                            />
                          </div>
                          {this.state.isTrainingStatusUpdate && (
                            <div className="col-sm-3 text-start align-self-center">
                              {/* <Button
                            style={{
                              background: "#37517e",
                              color: "white",
                              fontSize: "x-larger",
                              textTransform: "capitalize",
                              cursor: "pointer",
                              padding: "5px 20px",
                              fontWeight: "600",
                            }}
                            onClick={(e) =>
                              this.updateTrainingStatusInBackend()
                            }
                          >
                            Update
                          </Button> */}
                              <SaveButton
                                onClick={(e) =>
                                  this.updateTrainingStatusInBackend()
                                }
                              />
                              <ClearIcon
                                className="cancelIcon"
                                style={{
                                  cursor: "pointer",
                                  borderRadius: "50%",
                                  border: "solid 2px",
                                }}
                                onClick={this.editTrainingStatusCancel.bind(this)}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      {!this.state.isTextMessageLength ? (
                        <div className="row mt-2" style={{ minHeight: "40px" }}>
                          <label
                            className="col-sm-3 col-form-label fw-bold align-self-center"
                            style={{ width: "165px" }}
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Text Msg Length
                          </label>
                          <div
                            className="col-sm-5 align-self-center  ms-0 ps-0"
                            id="OrganizationCol"
                          >
                            <span>{this.state.textMessageLength}</span>
                          </div>
                          <div className="col-sm-3 text-start align-self-center">
                            <Button
                              variant="contained"
                              size="small"
                              style={{
                                background: "#d3d8de",
                                color: "#353538",
                                marginRight: "1rem",
                                float: "left",
                                padding: "2px 10px",
                                textTransform: "capitalize",
                              }}
                              startIcon={<EditIcon />}
                              onClick={this.editAccountTextMessageLength.bind(this)}
                            >
                              Edit
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div className="row mt-2">
                          <label
                            className="col-sm-3 col-form-label fw-bold align-self-center"
                            style={{ width: "165px" }}
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Text Msg Length
                          </label>
                          <div
                            className="col-sm-5 align-self-center  ms-0 ps-0"
                            id="OrganizationCol"
                          >
                            {/* <input
                          type="number"
                          autoComplete="off"
                          name="textmessagelength"
                          style={{ borderRadius: "5px" }}
                          className="form-control"
                          value={this.state.textMessageLength}
                          onChange={this.handleTextMessageLengthChange.bind(
                            this
                          )}
                        /> */}
                            <Autocomplete
                              id="size-small-outlined"
                              size="small"
                              fullWidth
                              disableClearable
                              autoComplete="off"
                              options={[
                                "160",
                                "313",
                                "466",
                                // { id: 1, length: "160" },
                                // { id: 1, length: "320" },
                              ]}
                              value={this.state.textMessageLength}
                              getOptionLabel={(option) => option}
                              defaultValue={this.state.textMessageLength}
                              onChange={(event, value) => {
                                this.handleTextMessageLengthChange(value);
                              }}
                              inputprops={{
                                style: { textTransform: "capitalize" },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Please Select"
                                  variant="outlined"
                                  size="small"
                                  className="autoComplete"
                                  style={{ background: "#fff" }}
                                />
                              )}
                            />
                          </div>
                          {this.state.isTrainingStatusUpdate && (
                            <div className="col-sm-3 align-self-center">
                              {/* <Button
                            style={{
                              background: "#37517e",
                              color: "white",
                              fontSize: "x-larger",
                              textTransform: "capitalize",
                              cursor: "pointer",
                              padding: "5px 20px",
                              fontWeight: "600",
                            }}
                            onClick={(e) =>
                              this.updateTextMessageLengthInBackend()
                            }
                          >
                            Update
                          </Button> */}
                              <SaveButton
                                onClick={(e) =>
                                  this.updateTextMessageLengthInBackend()
                                }
                              />
                              <ClearIcon
                                className="cancelIcon"
                                style={{
                                  cursor: "pointer",
                                  borderRadius: "50%",
                                  border: "solid 2px",
                                }}
                                onClick={this.editTextMessageCancel.bind(this)}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 p-0">
            <div className="mt-4" Style={{ maxWidth: "100%" }}>
              <MaterialTable
                title={
                  <span style={{ fontSize: "18px" }}>Account User Details</span>
                }
                icons={UiUtils.getMaterialTableIcons()}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h5 className="dataNotAvailable">
                        Please add account user
                      </h5>
                    ),
                  },
                }}
                columns={[
                  {
                    title: "#",
                    render: (rowData) => rowData.tableData?.id + 1,
                    width: "5%",
                    align: "left",
                    cellStyle: {
                      width: "6%",
                    },
                  },
                  {
                    title: "Name",
                    field: "name",
                    cellStyle: {
                      width: "20%",
                    },
                  },
                  {
                    title: "Email",
                    field: "email",
                    cellStyle: {
                      width: "25%",
                      textTransform: "lowercase",
                    },
                  },
                  {
                    title: "Profile",
                    field: "profileName",
                    render: (rowData) => {
                      return (
                        <>
                          {rowData.profileName}
                          <span className="ps-1">{rowData.isRegistered ? "(Primary)" : ""}</span>
                        </>
                      );
                    },
                    cellStyle: {
                      width: "20%",
                    },
                  },
                  {
                    title: "Status",
                    render: (rowData) => rowData.status?.status,
                    cellStyle: {
                      width: "15%",
                    },
                  },
                  {
                    title: "Actions",
                    sorting: false,
                    disableClick: true,
                    render: (rowData) => (
                      <>
                        {rowData.accountLocked && (
                          <Button
                            variant="contained"
                            size="small"
                            style={{
                              background: "#d3d8de",
                              color: "#353538",
                              textTransform: "capitalize",
                              marginRight: "5px",
                            }}
                            startIcon={<i className="fa-solid fa-unlock-keyhole"></i>}
                            onClick={() => this.accountLockToBackend(rowData)}
                          >
                            Unlock
                          </Button>
                        )}

                        {(!rowData.isRegistered && rowData.isMakePrimaryRequested) && (
                          <Tooltip
                            title="Make this user as primary user for this account."
                            classes={{ popper: "custom-tooltip" }}
                            arrow
                          >
                            <Button
                              type="button"
                              variant="contained"
                              id="ptsButton"
                              style={{
                                background: "green",
                                color: "#fff",
                                fontWeight: "bold",
                                textTransform: "capitalize",
                                padding: "2px 10px",
                              }}
                              onClick={() =>
                                this.approveMakePrimaryUserToBackend(rowData)
                              }
                            >
                              Approve
                            </Button>
                          </Tooltip>
                        )}
                      </>
                    ),
                    cellStyle: {
                      width: "10%",
                      cursor: "pointer",
                    },
                  }
                ]}
                data={this.state.userList}
                options={{
                  sorting: true,
                  searchAutoFocus: false,
                  emptyRowsWhenPaging: false,
                  actionsColumnIndex: -1,
                  initialPage: this.state.userInitialPage,
                  pageSize: this.state.userPageSize,
                  pageSizeOptions: [5, 10, 20, 50, 100],
                  paging: this.state.isUserPaging,
                  headerStyle: {
                    backgroundColor: "#37517e",
                    fontWeight: "bold",
                    color: "#ffff",
                    align: "left",
                  },
                }}
                showEmptyDataSourceMessage={false}
                onChangePage={(page, pageSize) => {
                  this.handleMaterialTablePageChange(page, pageSize);
                }}
              />
            </div>
          </div>
          <div className="col-md-12 mt-4 p-0">
            <div className="card" id="organizationFormCard">
              <div style={{ maxWidth: "100%" }}>
                <MaterialTable
                  title={
                    <span style={{ fontSize: "18px" }}>Activity Logs</span>
                  }
                  icons={UiUtils.getMaterialTableIcons("Add Note")}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">Please add Note</h5>
                      ),
                    },
                  }}
                  columns={[
                    {
                      title: "#",
                      render: (rowData) => rowData.tableData.id + 1,
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Created By",
                      render: (rowData) => rowData.createdbyName,
                      cellStyle: {
                        width: "20%",
                      },
                    },
                    {
                      title: "Created On",
                      render: (rowData) =>
                        rowData.createdon !== null
                          ? Utils.getUtcToLocalDateTimeZone(rowData.createdon)
                          : "",
                      cellStyle: {
                        width: "25%",
                      },
                    },
                    {
                      title: "Note",
                      field: "note",
                      cellStyle: {
                        width: "50%",
                      },
                      editComponent: (props) => (
                        <TextareaAutosize
                          aria-label="empty textarea"
                          placeholder="Note"
                          style={{ width: 510, padding: "10px" }}
                          value={props.value}
                          onChange={(e) => props.onChange(e.target.value)}
                        />
                      ),
                    },
                  ]}
                  editable={{
                    onRowAdd: this.state.getCreatePermission
                      ? (newData) =>
                        new Promise((resolve, reject) => {
                          this.createNoteToBackend(newData, resolve, reject);
                        })
                      : null,
                    onRowUpdate: this.state.getUpdatePermission
                      ? (newData) =>
                        new Promise((resolve, reject) => {
                          this.updateNotesToBackend(newData, resolve, reject);
                        })
                      : null,
                    onRowDelete: this.state.getDeletePermission
                      ? (data) =>
                        new Promise((resolve, reject) => {
                          this.deleteNoteToBackend(data, resolve, reject);
                        })
                      : null,
                  }}
                  data={this.state.noteList}
                  components={{
                    SearchField: (props) => (
                      <props.searchField
                        {...props}
                        autoComplete="off"
                        inputProps={{ autoComplete: "off" }}
                      />
                    ),
                  }}
                  options={{
                    sorting: true,
                    searchAutoFocus: false,
                    actionsColumnIndex: -1,
                    addRowPosition: "first",
                    emptyRowsWhenPaging: false,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    paging: this.state.isPaging,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    headerStyle: {
                      backgroundColor: "#37517e",
                      fontWeight: "bold",
                      color: "#ffff",
                      align: "left",
                    },
                    // rowStyle: (rowData) => ({
                    //   backgroundColor:
                    //     rowData.id === this.state.assetCodeId
                    //       ? "#FEF5E7"
                    //       : "#030303ff",
                    //   height: "3em",
                    //   textTransform: "capitalize",
                    // }),
                  }}
                />
              </div>
            </div>
          </div>

          <div className="mt-4 text-center">
            <Button
              type="submit"
              variant="contained"
              size="small"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                textTransform: "capitalize"
              }}
              startIcon={<ArrowBackIcon />}
              onClick={(e) => this.viewCancel()}
            >
              Back
            </Button>
          </div>
        </div >
        <Dialog
          open={this.state.accountStatusOpen}
          onClose={this.handleAccountStatusClose.bind(this)}
          onHide={this.close}
          style={{ padding: "1em" }}
        >
          <DialogContent style={{ width: "502px" }}>
            <span style={{ textAlign: "justify" }}>
              {this.state.status?.status === "Active" && (
                <p style={{ fontSize: "17px", lineHeight: "1.3em" }}>
                  You are about to reactivate this account. Credit card charges
                  will restart.
                </p>
              )}
              {this.state.status?.status === "Paused" && (
                <p style={{ fontSize: "17px", lineHeight: "1.3em" }}>
                  By <b>pausing</b> this account, users cannot login to their
                  account. Account data is saved in the database. Charges to the
                  credit card are paused. The toll free number is saved in
                  Twilio.
                </p>
              )}
              {this.state.status?.status === "Closed" && (
                <p style={{ fontSize: "17px", lineHeight: "1.3em" }}>
                  By <b>closing</b> this account, users cannot login to their
                  account. Account data is saved in the database. The credit
                  card is deleted. The toll free number is released from Twilio.
                </p>
              )}
              {this.state.status?.status === "Deleted" && (
                <p style={{ fontSize: "17px", lineHeight: "1.3em" }}>
                  By <b>deleting</b> this account, the account is fully wiped
                  from GivBee's server (including all user data and credit
                  card). The toll free number is released from Twilio.
                </p>
              )}
            </span>
            <div>
              <span style={{ textAlign: "center" }}>
                <h2 style={{ fontSize: "17px" }}>
                  Please enter your Password{" "}
                </h2>
              </span>
              <Row>
                <Col md={6} style={{ marginLeft: "auto", marginRight: "auto" }}>
                  <TextField
                    title=""
                    variant="outlined"
                    // margin="normal"
                    autoFocus={true}
                    size="small"
                    required
                    fullWidth
                    name="password"
                    type={this.state.showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="off"
                    onChange={this.handlePasswordChange.bind(this)}
                    value={this.state.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={this.handleClickShowPassword.bind(this)}
                          >
                            {this.state.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Col>
              </Row>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              padding: "2em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#0B6F9D",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<SaveIcon />}
              onClick={(e) => this.updateStatusInBackend(e)}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<CloseIcon />}
              onClick={this.handleAccountStatusClose.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.confirmWindowOpen}
          onClose={this.handleConfirmWindowClose.bind(this)}
          onHide={this.close}
          style={{ padding: "1em" }}
        >
          <DialogContent style={{ marginTop: "2em" }}>
            <span style={{ textAlign: "center" }}>
              <h2 style={{ fontSize: "20px" }}>Please enter your Password </h2>
            </span>
            <Row className="mt-4">
              <Col md={12} style={{ marginLeft: "auto", marginRight: "auto" }}>
                <TextField
                  title=""
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  type={this.state.showPassword ? "text" : "password"}
                  id="password"
                  autoComplete="off"
                  onChange={this.handlePasswordChange.bind(this)}
                  value={this.state.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={this.handleClickShowPassword.bind(this)}
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Col>
            </Row>
          </DialogContent>
          <DialogActions
            style={{ padding: "2em", marginLeft: "auto", marginRight: "auto" }}
          >
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#0B6F9D",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<SaveIcon />}
              onClick={(e) => this.deleteAccountInBackend(e)}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<CloseIcon />}
              onClick={this.handleConfirmWindowClose.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}
export default withRouter(AdminRegistration);
